
export default class CheckoutOption {
    constructor(
        public type: string,
        public label: string,
        public perItem: boolean,
        public price: number = 0.0,
        public nodeTypesJson: string
    ) { }
}